import { useState } from 'react'
import { Navigate, Outlet, Link } from 'react-router-dom'
import Icon from '@mdi/react'
import { mdiClose, mdiAlertOutline } from '@mdi/js'
import { Sidebar } from './Sidebar'
import { BottomNav } from './BottomNav'
import { useMe } from '@/hooks/useAuth'
import { PageSpinner } from '@/components/ui/Spinner'

export function Shell() {
  const { data: me, isLoading, isError } = useMe()
  const [dismissPasswordBanner, setDismissPasswordBanner] = useState(() => {
    try {
      return sessionStorage.getItem('dismissPasswordBanner') === 'true'
    } catch {
      return false
    }
  })

  if (isLoading) return <PageSpinner />
  if (isError) return <Navigate to="/login" replace />

  const showPasswordBanner = me && !me.has_password && !dismissPasswordBanner

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <main className="flex-1 flex flex-col min-w-0 pb-16 md:pb-0">
        {showPasswordBanner && (
          <div className="bg-amber-50 border-b border-amber-200 px-4 py-3 flex items-center justify-between gap-3">
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <Icon path={mdiAlertOutline} size={1} className="text-amber-600 flex-shrink-0" />
              <p className="text-sm text-amber-900">
                Set up a password to enable password login.
              </p>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              <Link
                to="/setup-password"
                className="text-sm font-medium text-amber-700 hover:text-amber-800 whitespace-nowrap"
              >
                Set password →
              </Link>
              <button
                onClick={() => {
                  setDismissPasswordBanner(true)
                  try {
                    sessionStorage.setItem('dismissPasswordBanner', 'true')
                  } catch {
                    // Ignore storage errors
                  }
                }}
                className="text-amber-600 hover:text-amber-700 p-1"
              >
                <Icon path={mdiClose} size={0.85} />
              </button>
            </div>
          </div>
        )}
        <Outlet />
      </main>
      <BottomNav />
    </div>
  )
}
